export default __webpack_public_path__ + "static/854-1cd72ff837a339d6e1222de56ff87818.gif";